import React, { FC } from 'react'
import { Empty, Grid, Table, TableColumnsType } from 'antd'
import { DataType, DataTypeArr } from '../types/statisticType'
import styles from './statistic-popover-content.module.scss'

interface PopoverPropsContent {
  columns: TableColumnsType<DataType> | undefined
  data: DataTypeArr | undefined
}

const StatisticPopoverContent: FC<PopoverPropsContent> = (props) => {
  const { columns, data } = props
  const screens = Grid.useBreakpoint()

  if (screens.md === false) {
    const entries: DataType[] = data || []
    if (!entries.length) return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Нет данных" />
    return (
      <ul className={styles.mobileList} aria-label="Статистика">
        {entries.map((entry) => (
          <li key={entry.key} className={styles.mobileEntry}>
            <div className={styles.name}>{entry.name}</div>
            {'date' in entry && (
              <div className={styles.details}>
                <span>{entry.date}</span>
                <span>{entry.time}</span>
              </div>
            )}
          </li>
        ))}
      </ul>
    )
  }

  return (
    <Table
      dataSource={data}
      columns={columns}
      pagination={false}
      scroll={{ y: 240 }}
      locale={{
        emptyText() {
          return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<span>Нет данных</span>} />
        },
      }}
    />
  )
}

export default StatisticPopoverContent
